import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadFleet, clearFleet } from '../redux/actions/fleetActions';

const EVERY_MS = 30000;

/**
 * Keeps hubs and staff in the store while signed in, so the header's bell and
 * the Overview count stay current on every page. Renders nothing.
 */
function FleetPoller({ enabled, load, clear }) {
  useEffect(() => {
    if (!enabled) {
      clear();
      return undefined;
    }
    // A failed poll keeps the last good data and tries again next time.
    const tick = () => load().catch(() => {});
    tick();
    const timer = setInterval(tick, EVERY_MS);
    return () => clearInterval(timer);
  }, [enabled, load, clear]);

  return null;
}

FleetPoller.propTypes = {
  enabled: PropTypes.bool.isRequired,
  load: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired
};

const mapDispatchToProps = (dispatch) => ({
  load: () => loadFleet(dispatch),
  clear: () => dispatch(clearFleet())
});

export default connect(null, mapDispatchToProps)(FleetPoller);
